(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/image-memo.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/image-memo.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  memo = _React.memo;
const Image = svs.content.image_v2.Image;
const getImageSource = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return image.src || image.url || image.noscriptUrl || image.originalUrl || '';
};
const areImagesEqual = (leftImage, rightImage) => {
  if (leftImage === rightImage) {
    return true;
  }
  if (!leftImage || !rightImage) {
    return leftImage === rightImage;
  }
  return getImageSource(leftImage) === getImageSource(rightImage) && leftImage.altText === rightImage.altText && leftImage.objectPosition === rightImage.objectPosition;
};
const ImageMemo = memo(_ref => {
  let image = _ref.image,
    _ref$cssSelectors = _ref.cssSelectors,
    cssSelectors = _ref$cssSelectors === void 0 ? '' : _ref$cssSelectors,
    _ref$fitWrapper = _ref.fitWrapper,
    fitWrapper = _ref$fitWrapper === void 0 ? false : _ref$fitWrapper,
    _ref$loadingLazy = _ref.loadingLazy,
    loadingLazy = _ref$loadingLazy === void 0 ? false : _ref$loadingLazy,
    onLoadCallback = _ref.onLoadCallback;
  return React.createElement(Image, {
    cssSelectors: cssSelectors,
    image: _objectSpread(_objectSpread({}, image), {}, {
      fitWrapper,
      loadingLazy
    }),
    onLoadCallback: onLoadCallback
  });
}, (previousProps, nextProps) => previousProps.cssSelectors === nextProps.cssSelectors && previousProps.fitWrapper === nextProps.fitWrapper && previousProps.loadingLazy === nextProps.loadingLazy && previousProps.onLoadCallback === nextProps.onLoadCallback && areImagesEqual(previousProps.image, nextProps.image));
setGlobal('svs.tickets.next.components.ImageMemo', ImageMemo);

 })(window);